export default __webpack_public_path__ + "static/media/formRewardImg.75c6fa1a.png";